import { render, staticRenderFns } from "./StudentData.vue?vue&type=template&id=65db131b&"
import script from "./StudentData.vue?vue&type=script&lang=ts&"
export * from "./StudentData.vue?vue&type=script&lang=ts&"
import style0 from "./StudentData.vue?vue&type=style&index=0&id=65db131b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports